export const GET_CATEGORIES_ACTION = "olap/getCategories";
export const GET_WORKERS_ACTION = "olap/getWorkers";
export const GET_REPORT_ACTION = "olap/getReport";
export const EDIT_REPORT_ACTION = "olap/editReport";
export const CREATE_REPORT_ACTION = "olap/createReport";
export const GET_REPORTS_IN_CATEGORY_ACTION = "olap/getReportsInCategory";
export const EDIT_CATEGORY_ACTION = "olap/editCategory";
export const CREATE_CATEGORY_ACTION = "olap/createCategory";
export const REMOVE_CATEGORY_ACTION = "olap/removeCategory";
export const REMOVE_REPORT_ACTION = "olap/removeReport";
export const RESORT_CATEGORIES_ACTION = "olap/resortCategories";
export const RESORT_REPORTS_ACTION = "olap/resortReports";
export const CHANGE_REPORT_CATEGORY_ACTION = "olap/changeReportCategory";
export const SAVE_REPORT_SETTINGS_ACTION = "olap/saveReportSettings";
export const GET_REPORT_SETTINGS_ACTION = "olap/fetchReportSettings";
